<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex my-4 pl-4 title align-center justify-center>Regulaminy</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="TERMS.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ REGULAMIN</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="terms"
        :actions="actions"
        :headers="table.headers"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="deleteTerms($event.id)"
      />

      <material-dialog
        :id="idToDelete"
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć regulamin?"
        :show="!!idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal
      :id="idToEdit"
      :show="showModal"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addTerms"
      @update="updateTerms"
    />
  </v-container>
</template>

<script>
import { ProfileType, ProfileTypeTranslation } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './addTerms.modal';

// @vuese
// Wyświetlanie listy regulaminów
// @group Terms
export default {
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal,
    Search
  },
  mixins: [
    listMixin('terms', {
      listError: 'Wystąpił błąd podczas pobierania listy regulaminów.',
      getError: 'Wystąpił błąd podczas pobierania danych regulaminu.',
      added: 'Dodano regulamin.',
      addError: 'Nie udało się dodać regulaminu.',
      updated: 'Zaktualizowano dane regulaminu.',
      updateError: 'Nie udało się zaktualizować danych regulaminu.',
      deleted: 'Usunięto regulamin.',
      deleteError: 'Nie udało się usunąć regulaminu.'
    })
  ],
  data() {
    return {
      table: {
        headers: [
          { value: 'name', text: 'Nazwa regulaminu', sortable: true },
          { value: 'start', text: 'Początek obowiązywania', sortable: false },
          { value: 'end', text: 'Koniec obowiązywania', sortable: false },
          {
            value: 'profileType',
            text: 'Typ profilu',
            sortable: true,
            orderBy: 'profileType',
            render: item => ProfileTypeTranslation[ProfileType[item.profileType]]
          }
        ]
      },
      actions: [DELETE_ACTION, EDIT_ACTION]
    };
  },
  computed: mapState({ list: state => state.terms.list }),

  methods: {
    // @vuese
    // Dodaje regulamin
    addTerms(data) {
      this.add({ terms: { ...data } });
    },
    // @vuese
    // Aktualizuje regulamin
    updateTerms(data) {
      const id = data.id;
      data.id = undefined;
      this.update({ terms: { ...data }, id });
    },
    // @vuese
    // Sprawdza czy można usunąć regulamin
    deleteTerms(id) {
      const selectedTerms = this.list.find(terms => terms.id === id);
      if (selectedTerms.consents && selectedTerms.consents.length > 0) {
        this.$store.dispatch('notifyError', { title: 'Nie można usunąć regulaminu, który posiada zgody' });
      } else {
        this.showDeleteDialog(id);
      }
    }
  }
};
</script>
